


















import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import { Alpaca } from '@/backend/type';
import { getPreview } from '@/backend/requests';

@Component({
  components: {
    AlpacaCard,
  },
})
export default class AlpacaPreview extends Vue {
  public previewAlpacas: Alpaca[] = [];

  public async mounted() {
    const res = await getPreview();
    if (res) {
      this.previewAlpacas = res.data.alpacas;
    }
  }
}
